import React from 'react';

const ManageRosterPageIndy = ({ roster, factions, participants, wrestlers, activeSection }) => {
  if (activeSection !== 'participants') {
    return null;
  }

  return (
    <section className="manage-roster-section">
      <div className="manage-roster-section__header">
        <div>
          <span className="manage-roster-section__eyebrow">Modalita indy</span>
          <h2>Partecipanti e fazioni</h2>
          <p>Controlla rapidamente chi ha gia creato la propria fazione e lo stato del roster.</p>
        </div>
      </div>

      {participants.length === 0 ? (
        <div className="manage-roster-empty">
          <i className="bi bi-people display-6" />
          <h3>Nessun partecipante presente</h3>
          <p>Invita altri utenti per iniziare a costruire il roster.</p>
        </div>
      ) : (
        <div className="manage-roster-grid">
          {participants.map((participant) => {
            const faction = factions.find((item) => item.ownerUid === participant.id);
            const isOwner = participant.id === roster.ownerUid;

            return (
              <article className="manage-roster-player-card" key={participant.id}>
                <div className="manage-roster-player-card__head">
                  <div>
                    <h3>{participant.username || participant.email || 'Utente'}</h3>
                    <p>{participant.email || participant.id}</p>
                  </div>
                  {isOwner && <span className="badge bg-brand-secondary text-dark">Proprietario</span>}
                </div>

                {faction ? (
                  <>
                    <div className="manage-roster-player-card__meta">
                      <div>
                        <small>Fazione</small>
                        <strong>{faction.name}</strong>
                      </div>
                      <div>
                        <small>Wrestler</small>
                        <strong>
                          {faction.wrestlerIds?.length || 0}/{roster.maxWrestlers}
                        </strong>
                      </div>
                    </div>
                    <div className="manage-roster-player-card__meta">
                      <div>
                        <small>Crediti residui</small>
                        <strong>{faction.creditsLeft || 0}</strong>
                      </div>
                      <div>
                        <small>Totale wrestler liberi</small>
                        <strong>{wrestlers.filter((wrestler) => wrestler.active).length}</strong>
                      </div>
                    </div>
                  </>
                ) : (
                  <div className="manage-roster-empty manage-roster-empty--inline">
                    <i className="bi bi-info-circle" />
                    <p>Nessuna fazione creata al momento.</p>
                  </div>
                )}
              </article>
            );
          })}
        </div>
      )}
    </section>
  );
};

export default ManageRosterPageIndy;
